/**
 * A 
 */
class Tracker {
  constructor() {
    this.clients = [];
  }
  init(options) {
    this.history = options.history;
    if (this.history) {
      this.unlisten = this.history.listen(this.pageView);
    }
  }
  destroy() {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }

  /**
   * Adds a track client. Returns true if the client has not
   * already been added
   */
  addClient(client) {
    if (client && !this.clients.includes(client)) {
      this.clients.push(client);
      return true;
    }
    return false;
  }

  /**
   * Removes a track client. Returns true if the client has been
   * successfully removed
   */
  removeClient(client) {
    const idx = this.clients.indexOf(client);
    if (idx >= 0) {
      this.clients.splice(idx, 1);
      return true;
    }
    return false;
  }

  /**
   * First a trackEvent to all clients.
   */
  pageView = location => {
    this.clients.forEach(c => {
      try {
        c.pageView(location);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    });
  };

  /**
   * First a trackEvent to all clients.
   */
  event = (action, data) => {
    this.clients.forEach(c => {
      try {
        c.event(action, data);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    });
  };
  set = (property, value) => {
    this.clients.forEach(c => {
      try {
        c.set?.(property, value);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    });
  };
}
const singleton = new Tracker();
export default singleton;